<template>
  <div>
    <img
      @click="EBelge()"
      src="../../../../assets/images/logo/efatura.png"
      class="img-fluid"
      style="width: 75px"
    />
  </div>
</template>
<script>
import state from "../../../../store/state";
const soap = require("soap");

export default {
  methods: {
    EBelge() {
      const url = this.params.data.url;
      const orderNumber = this.params.data.orderNumber;

      if (url && url.trim() !== "") {
        // URL varsa
        window.open(url, "_blank");
      } else {
        // URL yoksa
        const url = state.sistemAddress;
        const args = { orderNumber };

        soap.createClient(url, (err, client) => {
          if (err) {
            console.error("SOAP client hatası:", err);
            return;
          }

          client.FaturaHtmlGetir(args, (err, result) => {
            if (err) {
              console.error("SOAP çağrı hatası:", err);
              return;
            }

            try {
              if (result && result.FaturaHtmlGetirResult) {
                const data = JSON.parse(result.FaturaHtmlGetirResult);

                if (data && data.jsonData && data.jsonData.html) {
                  const html = data.jsonData.html;

                  const newWindow = window.open("", "_blank");
                  newWindow.document.open();
                  newWindow.document.write(html);
                  newWindow.document.close();
                } else {
                  console.warn("Beklenen HTML bulunamadı:", data);
                }
              } else {
                console.warn("Beklenen sonuç yok:", result);
              }
            } catch (e) {
              console.error("JSON parse hatası:", e, result.FaturaHtmlGetirResult);
            }
          });
        });
      }
    },
  },
};
</script>